import React, { useEffect } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import CoreModal from "../../core/layouts/CoreModal";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  FETCH_DEED_RECORDS_FAIL,
  FETCH_DEED_RECORDS_SUCCESS,
} from "../../store/types/deedTypes";
import { resetDeedReducer } from "../../store/actions/deedAction";

export default function DeedProcessorDashBoardModal({
  open,
  handleClose,
  data,
}) {
  const dispatch = useDispatch();

  const deedRecordsError = useSelector(
    (state) => state?.deed?.deedRecordsError,
  );
  const deedRecordsMessage = useSelector(
    (state) => state?.deed?.deedRecordsMessage,
  );
  const deedRecordsData = useSelector((state) => state?.deed?.deedRecordsData);

  useEffect(() => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/deed/records",
        { objectIdList: [data?._id] },
        null,
        null,
        FETCH_DEED_RECORDS_SUCCESS,
        FETCH_DEED_RECORDS_FAIL,
        true,
        false,
      ),
    );
  }, [data?._id]);

  useEffect(() => {
    if (deedRecordsError) {
      dispatch(resetDeedReducer({ deedRecordsError: false }));
      alert(deedRecordsMessage);
    }
  }, [deedRecordsError]);

  console.log("data", data);
  console.log("deedRecordsData", deedRecordsData);

  const matchedRecord = Array.isArray(deedRecordsData)
    ? deedRecordsData.find((record) => record._id === data?._id)
    : null;

  return (
    <CoreModal
      open={open}
      handleClose={handleClose}
      title="Deed Details"
      width={1200}
    >
      <Box sx={{ mt: 2, maxHeight: "70vh", overflowY: "auto" }}>
        {matchedRecord ? (
          <Grid container spacing={1} sx={{ mt: 1 }}>
            {Object.entries(matchedRecord).map(([k, v]) => {
              if (
                k === "id" ||
                k === "_id" ||
                k === "File_name" ||
                k === "file_name"
              )
                return null;

              return (
                <Grid item xs={3} key={k}>
                  <Box sx={{ mb: 0.5 }}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: "bold", textTransform: "uppercase" }}
                    >
                      {k.replace(/_/g, " ")}
                    </Typography>
                    <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                      {typeof v === "object"
                        ? JSON.stringify(v)
                        : String(v || "N/A")}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {deedRecordsData
              ? "No matching record found."
              : "Loading records..."}
          </Typography>
        )}
      </Box>
    </CoreModal>
  );
}
